module.exports = __webpack_public_path__ + "img/0x480CD4Fa911eeEFf93cB11135C97237455617862.217477a2.png";